export class RequestType {
    ID: number;
    Code: string;
    Name: string;
    CompletionNumberTypeID: number;
    HasRequestTypeFiles: boolean;
    SubmitUsingAPI: boolean;
    APIActive: boolean;
}

export default RequestType;